import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collapsed",
  "use": "icon-collapsed-usage",
  "viewBox": "0 0 1194 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1194 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-collapsed\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 853.333333h1194.666667v170.666667H0v-170.666667z m597.333333-426.666666h597.333334v170.666666H597.333333V426.666667zM0 0h1194.666667v170.666667H0V0z m0 256v512l443.733333-256L0 256z\" fill=\"#888888\" p-id=\"1926\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol